import { NavLink, Outlet, useResolvedPath } from "react-router-dom";
import { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";

const ResultsLayout = ({themesData}) => {
    //Get path of the ResultsLayout component (i.e. "/results")
    const url = useResolvedPath("").pathname;

    // State variable for themes navigation banner
    const [priorityThemes, setPriorityThemes] = useState([]);

    useEffect(() => {
      const getPriorityThemes = () => {
        const themesWithPriorityOne = themesData.filter((theme) => theme.priority === '1');
        setPriorityThemes(themesWithPriorityOne);
      };

      if (themesData.length > 0) {
        getPriorityThemes();
      }
    }, [themesData]);

  return (
    <div className="bg-black">

      <div className="container bg-black flex justify-center mx-auto py-5">
        <nav className="flex flex-wrap xl:flex-nowrap gap-2 xl:gap-4 justify-center xl:justify-start text-sm md:text-lg">
          <NavLink className="bg-black text-white border-2 border-white text-center p-1 rounded-md hover:bg-white hover:text-black" to={`${url}`} end> {/* By default, NavLink applies the active class to the link that matches the current route, and it also applies it to all parent links in the hierarchy. For example, if a theme is selected, the All button will also be active because the path associated with the All button (i.e. "/results") is the parent route of the theme routes. To prevent this behaviour we can add end prop to the All Navlink*/}
            All
          </NavLink>
        {priorityThemes.map((theme) => (
          <NavLink className="bg-black text-white border-2 border-white text-center p-1 rounded-md hover:bg-white hover:text-black transition-all" to={`${url}/${theme.url}`} key={theme.theme_name} >
            <p>{theme.theme_name}</p>
          </NavLink>
        ))}
        </nav>
      </div>

      <div className="flex justify-center">
        <SearchBar/>
      </div>

      <Outlet />
    </div>
  );
};

export default ResultsLayout;
